import './Card.css'
import { NavLogo_catering } from '../Navbar/NavbarElements'

const Card = () => {
  return (
    <>
    <div className='title_con'>
        <div className='title_card'>
            Vår Meny
        </div>
    </div>
    <div className='grid-container_container'>
        <div className='card_con'>
            <div className='wrapper_catering'>
                <div className='card_area'>
                    <div className='card'>
                        <div className='catering_pic' />
                        <div className='overlay_catering'>
                            <NavLogo_catering to='/menuLeb'>
                                <p>Libanesisk buffé</p>
                                <div className='btn_meny'>Visa menyn</div>
                            </NavLogo_catering>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='catering_pic2' />
                        <div className='overlay_catering'>
                            <NavLogo_catering to='/menuJap'>
                            <br /><br />
                                <p>Japansk buffé</p>
                                <div className='btn_meny'>Visa menyn</div>
                            </NavLogo_catering>
                        </div>
                    </div>
                <div className='card'>
                        <div className='catering_pic3' />
                        <div className='overlay_catering'>
                            <NavLogo_catering to='/menuMex'>
                                <p>Mexikansk buffé</p>
                                <div className='btn_meny'>Visa menyn</div>
                            </NavLogo_catering>
                        </div>
                    </div>
                <div className='card'>
                        <div className='catering_pic4' />
                        <div className='overlay_catering'>
                            <NavLogo_catering to='/menuGre'>
                                <br /><br />
                                <p>Grekisk buffé</p>
                                <div className='btn_meny'>Visa menyn</div>
                            </NavLogo_catering>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='catering_pic5' />
                        <div className='overlay_catering'>
                            <NavLogo_catering to='/menuSka'>
                                <p>Skandinavisk buffé</p>
                                <div className='btn_meny'>Visa menyn</div>
                            </NavLogo_catering>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='catering_pic6' />
                        <div className='overlay_catering'>
                            <NavLogo_catering to='/menuVie'>
                                <p>Vietnamesisk buffé</p>
                                <div className='btn_meny'>Visa menyn</div>
                            </NavLogo_catering>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='catering_pic7' />
                        <div className='overlay_catering'>
                            <NavLogo_catering to='/menuTha'>
                                <br /><br /><br />
                                <p>Thai buffé</p>
                                <div className='btn_meny'>Visa menyn</div>
                            </NavLogo_catering>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='catering_pic8' />
                        <div className='overlay_catering'>
                            <NavLogo_catering to='/menuIta'>
                                <br /><br />
                                <p>Italiensk buffé</p>
                                <div className='btn_meny'>Visa menyn</div>
                            </NavLogo_catering>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='catering_pic9' />
                        <div className='overlay_catering'>
                            <NavLogo_catering to='/menuInd'>
                            <br /><br />
                                <p>Indisk buffé</p>
                                <div className='btn_meny'>Visa menyn</div>
                            </NavLogo_catering>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='catering_pic10' />
                        <div className='overlay_catering'>
                            <NavLogo_catering to='/menuFra'>
                                <br /><br />
                                <p>Fransk buffé</p>
                                <div className='btn_meny'>Visa menyn</div>
                            </NavLogo_catering>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='catering_pic11' />
                        <div className='overlay_catering'>
                            <NavLogo_catering to='/menuPer'>
                                <br /><br />
                                <p>Persian buffé</p>
                                <div className='btn_meny'>Visa menyn</div>
                            </NavLogo_catering>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='catering_pic12' />
                        <div className='overlay_catering'>
                            <NavLogo_catering to='/menuPeru'>
                                <br /><br />
                                <p>Peruvian buffé</p>
                                <div className='btn_meny'>Visa menyn</div>
                            </NavLogo_catering>
                        </div>
                    </div>
                      <div className='card'>
                        <div className='catering_pic13' />
                        <div className='overlay_catering'>
                            <NavLogo_catering to='/breakfast'>
                                <br /><br /><br />
                                <p>Frukost</p>
                                <div className='btn_meny'>Visa menyn</div>
                            </NavLogo_catering>
                        </div>
                    </div>
                     <div className='card'>
                        <div className='catering_pic14' />
                        <div className='overlay_catering'>
                            <NavLogo_catering to='/lunch'>
                                <br /><br /><br />
                                <p>Lunch</p>
                                <div className='btn_meny'>Visa menyn</div>
                            </NavLogo_catering>
                        </div>
                    </div>
                     <div className='card'>
                        <div className='catering_pic15' />
                        <div className='overlay_catering'>
                            <p>Julbord</p>
                        </div>
                    </div>
                     <div className='card'>
                        <div className='catering_pic16' />
                        <div className='overlay_catering'>
                            <p>Food Truck</p>
                        </div>
                    </div>
                     <div className='card'>
                        <div className='catering_pic17' />
                        <div className='overlay_catering'>
                            <p>Smash Burger</p>
                        </div>
                    </div>
                     <div className='card'>
                        <div className='catering_pic18' />
                        <div className='overlay_catering'>
                            <p>El Birria</p>
                        </div>
                    </div>
                     <div className='card'>
                        <div className='catering_pic19' />
                        <div className='overlay_catering'>
                            <p>Shawarma</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</>
  )
}

export default Card